import React from 'react';
import {Header as HeaderEager} from './Header.eager';
import {
  Header as HeaderBase,
  SpecialLogoWrapper,
} from '@aboutyou/ui-components';
import styled from 'styled-components';
import {AboutYouLogo} from '@aboutyou/logic-components';
import {useCurrentPageType} from '@aboutyou/router';

export const Header = () => {
  const isCheckoutPage = useCurrentPageType() === 'checkout';

  if (isCheckoutPage) {
    return (
      <DesktopHeaderBase
        onMenuClick={() => {}}
        wishlistCount={0}
        basketCount={0}
        isCheckout={true}
        logoComponent={
          <StyledAboutYouLogo
            disableSvgLogo
            disableBasCampaignTakeover
            disableWoohoo
            disableShowUserName={isCheckoutPage}
          />
        }
      />
    );
  }

  return <HeaderEager />;
};

const DesktopHeaderBase = styled(HeaderBase)`
  position: relative;

  ${SpecialLogoWrapper} a {
    justify-content: center;
  }

  ${SpecialLogoWrapper}~a {
    position: absolute;
    right: 16%;
    top: auto;
    margin-inline-end: 0;
  }
`;

const StyledAboutYouLogo = styled(AboutYouLogo)`
  flex: 0 0 33%;
  justify-content: center;
  max-width: 33%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
`;
